import React, { useEffect, useState } from "react";
import { Modal } from "react-bootstrap";
import { FiRefreshCw } from "react-icons/fi";
import api from "api";
import { formatDate, formatPrice, debug } from "utils";


export default function OrderPaymentsModal({
  show,
  order,
  onClose
}) {
  const [payments, setPayments] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const loadPayments = async () => {
    if (!order?.orderId) return;
    try {
      setLoading(true);
      setError(null);
      const res = await api.get(
        `/admin/orders/${order.orderId}/payments`
      );
      setPayments(res.data || []);
    } catch {
      setError("Impossible de charger les paiements");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (show) {
      loadPayments();
    }
  }, [show]);

  return (
    <Modal show={true} onHide={onClose} centered size="lg">
      <Modal.Header closeButton>
        <Modal.Title>
          Paiements reçus pour la facture {order?.formatedNumber}
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {loading && <div>Chargement...</div>}
        {error && <div className="text-danger">{error}</div>}

        {!loading && !error && (
          <table className="table table-sm">
            <thead>
              <tr>
                <th>Date</th>
                <th>Mode</th>
                <th>Montant</th>
                <th>Complet</th>
                <th>Opérateur ID</th>
              </tr>
            </thead>
            <tbody>
              {payments.length === 0 && (
                <tr>
                  <td colSpan="5" className="text-center">
                    Aucun paiement
                  </td>
                </tr>
              )}

              {payments.map((pay) => (
                <tr key={pay.payId}>
                  <td className="text-center">{formatDate(pay.payCreatedAt, 'd/m/Y H:i')}</td>
                  <td className="text-center">{pay.payMode}</td>
                  <td className="text-center">{formatPrice(pay.payAmount)}&nbsp;€</td>
                  <td className={`text-center ${pay.payFull === "1" ? 'text-primary' : 'text-danger'}`}>
                    {pay.payFull === "1" ? "Oui" : "Non"}
                  </td>
                  <td className="small text-muted text-center">
                    {pay.payOperatorId}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        )}
      </Modal.Body>
    </Modal>
  );
}